import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/API/api.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  aboutContent: any;
  aboutImage: any;
  working_hours: string = ''
  phone: string = ''
  email: string = ''
  address: string = ''

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.lodadAboutContent();
  }

  lodadAboutContent(){
    this.apiService.vendorSettings().subscribe({
      next: response => {
        this.aboutContent = response.settings.about_us;
        this.aboutImage = response.settings.about_us_img;
        this.working_hours = response.settings.working_hours;
        this.phone = response.settings.phone;
        this.email = response.settings.email;
        this.address = response.settings.address;

      }, 
      error: (error: any) => {
        console.log(error);
      }
    });
  }
}
